(function() {
  'use strict';

  angular
    .module('cfn')
    .factory('arrayItemKeyFilterService', arrayItemKeyFilterService);

  function arrayItemKeyFilterService() {
    /**
     * filter function
     * @param  {object} dataItem
     * @param  {mixed} filterValue
     * @param  {object} filterConfig
     * @return {Boolean}
     */
    return function(dataItem, filterValue, filterConfig) {
      return !!_.chain(dataItem[filterConfig.dataItemProperty])
        .some(function(item) {
          return filterValue === item[filterConfig.dataItemKey];
        })
        .value();
    };
  }
})();
